import { useNavigate } from 'react-router-dom';
import { EllipsisVertical, Pencil } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { TableCell, TableRow } from '@/components/ui/table';
import { convertToDateFormat } from '@/helpers/dateHelpers';

const TenantRow = ({ tenant }) => {
  const navigate = useNavigate();

  return (
    <>
      <TableRow
        onClick={() => navigate(`/tenant/${tenant.id}`)}
        className="cursor-pointer"
      >
        <TableCell className="py-2">{tenant.name}</TableCell>
        <TableCell className="py-2">
          {convertToDateFormat(tenant.createdAt)}
        </TableCell>
        <TableCell className="text-right py-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
              <Button variant="icon" size="icon" aria-label="Open menu">
                <EllipsisVertical size={18} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent onClick={(e) => e.stopPropagation()}>
              <DropdownMenuLabel>{tenant.name}</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                onClick={() => navigate(`/tenant/${tenant.id}`)}
              >
                <Pencil />
                Edit Tenant
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </TableCell>
      </TableRow>
    </>
  );
};

export default TenantRow;
